module.exports = __webpack_public_path__ + "img/icon-care.cd46c705.png";